// extracted by mini-css-extract-plugin
export var circle = "_2t-2";
export var icon = "_2t-a";
export var iconHighlight = "_2t-0";
export var lg = "_2t-8";
export var md = "_2t-7";
export var outline = "_2t-4";
export var sm = "_2t-6";
export var square = "_2t-1";
export var xl = "_2t-9";
export var xs = "_2t-5";
export var xxs = "_2t-3";